<div class="tooltip-content" [class.dark]="dark()" [class.big]="big()">
  @if (imageUrl()) {
    <div class="asset-container">
      <img [src]="imageUrl()" alt="" />
    </div>
  } @else if (videoUrl()) {
    <div class="asset-container">
      <video [src]="videoUrl()" #videoEl loop muted playsinline disablepictureinpicture="true"></video>
    </div>
  }
  @if (title()) {
    <h3>{{ title() }}</h3>
  }
  @if (!htmlContent()) {
    <div class="tooltip-inner">
      {{ text() }}
      @if (keyboardShortcut()) {
        <span class="shortcut">
          @if (keyboardShortcutMeta()) {
            <span>{{ metaKey() }}+</span>
          }
          {{ keyboardShortcut() }}</span
        >
      }
    </div>
  } @else {
    <div [innerHTML]="htmlContent()"></div>
  }
</div>
